import React from 'react'
import ArticleComp1 from '../components/ArticleComp1'
import ArticleComp2 from '../components/ArticleComp2'

const Article = () => {
  return (
    <div>
        <ArticleComp1/>
        <ArticleComp2/>
    </div>
  )
}

export default Article